import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { HeaderClosable, HaOverviewContainer } from 'features';
import { LocaleSelectContext } from 'layouts/LocaleProvider/LocaleProvider';
import { useAppSelector } from 'store/hooks';
import { selectCurrentStore } from 'store/store/selectors';

import styles from './index.module.scss';

export function HaOverview() {
  const store = useAppSelector(selectCurrentStore);
  const localeContext = useContext(LocaleSelectContext);
  const seriesEnabled = store.settings && store.settings.series && store.settings.series.enabled;

  if (!seriesEnabled) {
    return <Navigate to="/calendar" replace />;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={localeContext?.locale || 'en'}>
      <div className={styles.root}>
        <HeaderClosable to="/calendar" />
        <HaOverviewContainer />
      </div>
    </LocalizationProvider>
  );
}
